class FacebookLiveMessage {
  id: string;

  broadcastId: string;

  pageId: string;

  commentId: string;

  userId: string;

  userName: string;

  text: string;

  timestamp: Date;

  createdAt: Date;

  crmSynced: boolean;

  crmSyncedAt: Date | null;

  constructor({
    id,
    broadcastId,
    pageId,
    commentId,
    userId,
    userName,
    text,
    timestamp,
    createdAt,
    crmSynced,
    crmSyncedAt,
  }: {
    id: string;
    broadcastId: string;
    pageId: string;
    commentId: string;
    userId: string;
    userName: string;
    text: string;
    timestamp: Date;
    createdAt: Date;
    crmSynced: boolean;
    crmSyncedAt: Date | null;
  }) {
    this.id = id;
    this.broadcastId = broadcastId;
    this.pageId = pageId;
    this.commentId = commentId;
    this.userId = userId;
    this.userName = userName;
    this.text = text;
    this.timestamp = timestamp;
    this.createdAt = createdAt;
    this.crmSynced = crmSynced;
    this.crmSyncedAt = crmSyncedAt;
  }

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  static fromApiResponse(columns: string[], rows: any[][]): FacebookLiveMessage[] {
    if (rows.length === 0) {
      return [];
    }
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return rows.map((row: any[]) => {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      const data: any = {};
      columns.forEach((column, index) => {
        const camelCaseKey = column.replace(/_([a-z])/g, (match, letter) => letter.toUpperCase());
        if (row[index] && (camelCaseKey === 'timestamp' || camelCaseKey === 'createdAt' || camelCaseKey === 'crmSyncedAt')) {
          data[camelCaseKey] = new Date(row[index]);
        } else {
          data[camelCaseKey] = row[index];
        }
      });
      return new FacebookLiveMessage(data);
    });
  }
}

export default FacebookLiveMessage;
